module.exports = {
    "scalars": [
        0,
        1,
        2,
        4,
        6,
        7,
        8,
        9,
        10,
        14,
        44,
        60,
        89,
        91,
        92,
        93,
        125,
        133,
        134,
        142
    ],
    "types": {
        "BigInt": {},
        "DateTime": {},
        "JSON": {},
        "Mutation": {
            "v1DeleteEmbeddings": [
                25,
                {
                    "options": [
                        27
                    ],
                    "users": [
                        4,
                        "[String!]!"
                    ]
                }
            ],
            "v1UpdateCompanies": [
                117,
                {
                    "updates": [
                        11,
                        "[V1UpdateCompanyByIdData!]!"
                    ]
                }
            ],
            "v1UpdateEmbeddings": [
                119,
                {
                    "embeddings": [
                        26,
                        "[v1EmbeddingData!]!"
                    ]
                }
            ],
            "v1UpdateUser": [
                121,
                {
                    "data": [
                        13,
                        "V1UpdateUserData!"
                    ],
                    "id": [
                        4,
                        "String!"
                    ]
                }
            ],
            "v1UpdateUserNotifications": [
                120,
                {
                    "notifications": [
                        132,
                        "[v1UserNotificationInput!]!"
                    ]
                }
            ],
            "v1UpdateUsers": [
                122,
                {
                    "updates": [
                        12,
                        "[V1UpdateUserByIdData!]!"
                    ]
                }
            ],
            "__typename": [
                4
            ]
        },
        "String": {},
        "Query": {
            "v1AnalyzeText": [
                15,
                {
                    "analyzer": [
                        4
                    ],
                    "attributes": [
                        4,
                        "[String]"
                    ],
                    "charFilter": [
                        4,
                        "[String]"
                    ],
                    "explain": [
                        6
                    ],
                    "field": [
                        4
                    ],
                    "filter": [
                        4,
                        "[String]"
                    ],
                    "index": [
                        4
                    ],
                    "normalizer": [
                        4
                    ],
                    "text": [
                        4,
                        "String!"
                    ],
                    "tokenizer": [
                        4
                    ]
                }
            ],
            "v1AutoCompleteUsers": [
                18,
                {
                    "filter": [
                        17
                    ],
                    "page": [
                        33
                    ],
                    "sort": [
                        34,
                        "[v1EntitySort]"
                    ]
                }
            ],
            "v1ExplainTargeter": [
                37,
                {
                    "filter": [
                        90
                    ],
                    "id": [
                        4,
                        "String!"
                    ],
                    "rankingFactors": [
                        94
                    ]
                }
            ],
            "v1FulltextSearchUsers": [
                39,
                {
                    "filter": [
                        38
                    ],
                    "page": [
                        33
                    ],
                    "sort": [
                        34,
                        "[v1EntitySort]"
                    ]
                }
            ],
            "v1ListCities": [
                48,
                {
                    "applicationName": [
                        4
                    ],
                    "filter": [
                        19
                    ],
                    "sort": [
                        34,
                        "[v1EntitySort]"
                    ]
                }
            ],
            "v1ListCompanies": [
                49,
                {
                    "applicationName": [
                        4
                    ],
                    "filter": [
                        22
                    ],
                    "page": [
                        33
                    ],
                    "sort": [
                        34,
                        "[v1EntitySort]"
                    ],
                    "sortBy": [
                        4
                    ]
                }
            ],
            "v1ListIndustries": [
                51,
                {
                    "applicationName": [
                        4
                    ],
                    "filter": [
                        45
                    ],
                    "page": [
                        33
                    ],
                    "sort": [
                        34,
                        "[v1EntitySort]"
                    ]
                }
            ],
            "v1ListProvinces": [
                52,
                {
                    "applicationName": [
                        4
                    ],
                    "filter": [
                        80
                    ],
                    "sort": [
                        34,
                        "[v1EntitySort]"
                    ]
                }
            ],
            "v1ListRoleCategories": [
                53,
                {
                    "applicationName": [
                        4
                    ],
                    "filter": [
                        82
                    ],
                    "page": [
                        33
                    ],
                    "sort": [
                        34,
                        "[v1EntitySort]"
                    ]
                }
            ],
            "v1ListSkills": [
                54,
                {
                    "applicationName": [
                        4
                    ],
                    "filter": [
                        104
                    ],
                    "page": [
                        33
                    ],
                    "sort": [
                        34,
                        "[v1EntitySort]"
                    ]
                }
            ],
            "v1ListUsers": [
                55,
                {
                    "applicationName": [
                        4
                    ],
                    "filter": [
                        130
                    ],
                    "page": [
                        33
                    ],
                    "sort": [
                        34,
                        "[v1EntitySort]"
                    ]
                }
            ],
            "v1QueryEmbeddings": [
                50,
                {
                    "filter": [
                        30
                    ],
                    "size": [
                        7
                    ]
                }
            ],
            "v1SearchMissionApplications": [
                86,
                {
                    "applicationName": [
                        4
                    ],
                    "filter": [
                        85
                    ],
                    "page": [
                        33
                    ],
                    "sort": [
                        34,
                        "[v1EntitySort]"
                    ]
                }
            ],
            "v1SearchMissions": [
                88,
                {
                    "applicationName": [
                        4
                    ],
                    "filter": [
                        87
                    ],
                    "page": [
                        33
                    ],
                    "sort": [
                        34,
                        "[v1EntitySort]"
                    ]
                }
            ],
            "v1SearchUsers": [
                98,
                {
                    "applicationName": [
                        4
                    ],
                    "filter": [
                        90
                    ],
                    "indexName": [
                        4
                    ],
                    "page": [
                        33
                    ],
                    "queryRoleId": [
                        4
                    ],
                    "rankingFactors": [
                        94
                    ],
                    "sort": [
                        34,
                        "[v1EntitySort]"
                    ]
                }
            ],
            "v1SuggestUsers": [
                107,
                {
                    "filter": [
                        106
                    ],
                    "page": [
                        33
                    ],
                    "sort": [
                        34,
                        "[v1EntitySort]"
                    ]
                }
            ],
            "__typename": [
                4
            ]
        },
        "Boolean": {},
        "Int": {},
        "Time": {},
        "UUID": {},
        "Upload": {},
        "V1UpdateCompanyByIdData": {
            "data": [
                118
            ],
            "id": [
                4
            ],
            "__typename": [
                4
            ]
        },
        "V1UpdateUserByIdData": {
            "data": [
                13
            ],
            "id": [
                4
            ],
            "__typename": [
                4
            ]
        },
        "V1UpdateUserData": {
            "activeOnMission": [
                6
            ],
            "activeRoles": [
                4
            ],
            "appliedIndustries": [
                4
            ],
            "appliedRequiredSkillIds": [
                4
            ],
            "appliedRoles": [
                4
            ],
            "assignedRoles": [
                4
            ],
            "assignedSpecializations": [
                4
            ],
            "badges": [
                125
            ],
            "blurbs": [
                2
            ],
            "calculatedYearsOfExperience": [
                7
            ],
            "communityBadges": [
                4
            ],
            "companies": [
                2
            ],
            "companiesV2": [
                24
            ],
            "currentlyInterviewing": [
                4
            ],
            "currentlyProposed": [
                4
            ],
            "declaredProjectIndustries": [
                4
            ],
            "endedRoles": [
                4
            ],
            "estimatedAvailability": [
                14
            ],
            "hasPerformanceIssue": [
                6
            ],
            "highQualityProfile": [
                14
            ],
            "highQualityProfileV1": [
                14
            ],
            "hourlyRate": [
                128
            ],
            "industriesExperience": [
                2
            ],
            "industriesExperienceWithSuggestions": [
                2
            ],
            "jobExperiences": [
                47
            ],
            "latestApplicationDate": [
                4
            ],
            "latestAvailabilityEstimate": [
                1
            ],
            "missionApplicationPitches": [
                2
            ],
            "missionStatusDate": [
                4
            ],
            "notInterestedRoles": [
                4
            ],
            "profileCompleteness": [
                14
            ],
            "profileCompletenessV1": [
                14
            ],
            "profilePictureIssues": [
                4
            ],
            "profileScore": [
                14
            ],
            "profileVector": [
                14
            ],
            "projectExperiences": [
                78
            ],
            "proposalCount": [
                7
            ],
            "proposedSkills": [
                4
            ],
            "proposedSpecializations": [
                4
            ],
            "recommendedRoleIds": [
                4
            ],
            "region": [
                4
            ],
            "resume": [
                4
            ],
            "similarBuilders": [
                101
            ],
            "strictScore": [
                14
            ],
            "suggestedBuilderHourlyRate": [
                14
            ],
            "suggestedJobExperiences": [
                110
            ],
            "suggestedProjectExperiences": [
                112
            ],
            "suggestedSkills": [
                36
            ],
            "suggestedSpecializations": [
                36
            ],
            "timesheetSummaries": [
                114
            ],
            "transcripts": [
                115
            ],
            "trustedTalentProfile": [
                140
            ],
            "vectorizedTexts": [
                100
            ],
            "verifiedSkills": [
                4
            ],
            "vettingFeedbackForm": [
                2
            ],
            "__typename": [
                4
            ]
        },
        "Float": {},
        "v1AnalyzeTextQueryOutput": {
            "detail": [
                2
            ],
            "tokens": [
                2
            ],
            "__typename": [
                4
            ]
        },
        "v1AutoCompleteUsersCompletionsApi": {
            "createdAt": [
                4
            ],
            "displayEmail": [
                4
            ],
            "email": [
                4
            ],
            "fullName": [
                4
            ],
            "highlight": [
                2
            ],
            "metadata": [
                2
            ],
            "score": [
                14
            ],
            "uid": [
                4
            ],
            "updatedAt": [
                4
            ],
            "__typename": [
                4
            ]
        },
        "v1AutoCompleteUsersFilterApi": {
            "query": [
                4
            ],
            "__typename": [
                4
            ]
        },
        "v1AutoCompleteUsersOutput": {
            "completions": [
                16
            ],
            "currentPage": [
                7
            ],
            "metadata": [
                2
            ],
            "pageSize": [
                7
            ],
            "totalPages": [
                7
            ],
            "totalRecords": [
                7
            ],
            "__typename": [
                4
            ]
        },
        "v1CityListFilterApi": {
            "cityName": [
                4
            ],
            "countryCode": [
                4
            ],
            "province": [
                4
            ],
            "__typename": [
                4
            ]
        },
        "v1CompanyEnrichment": {
            "apollo": [
                2
            ],
            "clearbit": [
                2
            ],
            "structured": [
                105
            ],
            "__typename": [
                4
            ]
        },
        "v1CompanyEntityApi": {
            "_id": [
                4
            ],
            "allDomains": [
                4
            ],
            "childIds": [
                4
            ],
            "clientWorkspaces": [
                4
            ],
            "createdAt": [
                1
            ],
            "createdBy": [
                4
            ],
            "domainAliases": [
                4
            ],
            "employeeCount": [
                7
            ],
            "enrichment": [
                20
            ],
            "fld": [
                4
            ],
            "metadata": [
                2
            ],
            "name": [
                4
            ],
            "nameAliases": [
                4
            ],
            "parentId": [
                4
            ],
            "pipelineUpdatedAt": [
                1
            ],
            "requiresDeepEnrichment": [
                6
            ],
            "updatedAt": [
                1
            ],
            "url": [
                4
            ],
            "__typename": [
                4
            ]
        },
        "v1CompanyListFilterApi": {
            "accountIds": [
                4
            ],
            "deeplyEnriched": [
                6
            ],
            "dropDuplicates": [
                6
            ],
            "ids": [
                4
            ],
            "isClient": [
                6
            ],
            "linkedinUrl": [
                4
            ],
            "query": [
                4
            ],
            "requiresDeepEnrichment": [
                6
            ],
            "simplyEnriched": [
                6
            ],
            "__typename": [
                4
            ]
        },
        "v1CompanyV2": {
            "companyV2Id": [
                4
            ],
            "name": [
                4
            ],
            "sourceId": [
                4
            ],
            "sourceType": [
                4
            ],
            "__typename": [
                4
            ]
        },
        "v1CompanyV2Mutation": {
            "companyV2Id": [
                4
            ],
            "name": [
                4
            ],
            "sourceId": [
                4
            ],
            "sourceType": [
                4
            ],
            "__typename": [
                4
            ]
        },
        "v1DeleteEmbeddingsOutput": {
            "currentPage": [
                7
            ],
            "metadata": [
                2
            ],
            "pageSize": [
                7
            ],
            "totalPages": [
                7
            ],
            "totalRecords": [
                7
            ],
            "__typename": [
                4
            ]
        },
        "v1EmbeddingData": {
            "embeddedAt": [
                1
            ],
            "ref": [
                4
            ],
            "text": [
                4
            ],
            "type": [
                4
            ],
            "user": [
                4
            ],
            "vector": [
                14
            ],
            "__typename": [
                4
            ]
        },
        "v1EmbeddingDeleteOptions": {
            "embeddedBefore": [
                1
            ],
            "__typename": [
                4
            ]
        },
        "v1EmbeddingOutput": {
            "embeddedAt": [
                1
            ],
            "metadata": [
                2
            ],
            "ref": [
                4
            ],
            "text": [
                4
            ],
            "type": [
                4
            ],
            "user": [
                4
            ],
            "vector": [
                14
            ],
            "__typename": [
                4
            ]
        },
        "v1EmbeddingUserOutput": {
            "user": [
                4
            ],
            "__typename": [
                4
            ]
        },
        "v1EmbeddingsFilterApi": {
            "query": [
                4
            ],
            "types": [
                4
            ],
            "users": [
                4
            ],
            "__typename": [
                4
            ]
        },
        "v1EntityAggregation": {
            "buckets": [
                32
            ],
            "doc_count_error_upper_bound": [
                7
            ],
            "sum_other_doc_count": [
                7
            ],
            "__typename": [
                4
            ]
        },
        "v1EntityAggregationBucket": {
            "doc_count": [
                7
            ],
            "key": [
                4
            ],
            "label": [
                4
            ],
            "__typename": [
                4
            ]
        },
        "v1EntityPage": {
            "current": [
                7
            ],
            "size": [
                7
            ],
            "__typename": [
                4
            ]
        },
        "v1EntitySort": {
            "field": [
                4
            ],
            "order": [
                4
            ],
            "__typename": [
                4
            ]
        },
        "v1ExperienceGraphPrediction": {
            "confidence": [
                14
            ],
            "id": [
                4
            ],
            "__typename": [
                4
            ]
        },
        "v1ExperienceGraphPredictionInput": {
            "confidence": [
                14
            ],
            "id": [
                4
            ],
            "__typename": [
                4
            ]
        },
        "v1ExplainTargeterQueryOutput": {
            "esOriginalExplanations": [
                2
            ],
            "esParsedExplanations": [
                2
            ],
            "esQuery": [
                2
            ],
            "esSearchHighlight": [
                2
            ],
            "id": [
                4
            ],
            "matched": [
                6
            ],
            "matchedValues": [
                2
            ],
            "structuredExplanations": [
                2
            ],
            "__typename": [
                4
            ]
        },
        "v1FulltextSearchUsersFilterApi": {
            "id": [
                4
            ],
            "query": [
                4
            ],
            "__typename": [
                4
            ]
        },
        "v1FulltextSearchUsersOutput": {
            "currentPage": [
                7
            ],
            "metadata": [
                2
            ],
            "pageSize": [
                7
            ],
            "totalPages": [
                7
            ],
            "totalRecords": [
                7
            ],
            "users": [
                40
            ],
            "__typename": [
                4
            ]
        },
        "v1FulltextSearchUsersUsersApi": {
            "createdAt": [
                4
            ],
            "displayEmail": [
                4
            ],
            "email": [
                4
            ],
            "fullName": [
                4
            ],
            "metadata": [
                2
            ],
            "uid": [
                4
            ],
            "updatedAt": [
                4
            ],
            "__typename": [
                4
            ]
        },
        "v1IndustriesExperience": {
            "industryId": [
                4
            ],
            "minYearsOfExperience": [
                14
            ],
            "references": [
                43
            ],
            "__typename": [
                4
            ]
        },
        "v1IndustryEntityApi": {
            "_id": [
                4
            ],
            "description": [
                4
            ],
            "name": [
                4
            ],
            "textId": [
                4
            ],
            "__typename": [
                4
            ]
        },
        "v1IndustryExperienceReference": {
            "referenceId": [
                4
            ],
            "type": [
                44
            ],
            "__typename": [
                4
            ]
        },
        "v1IndustryExperienceType": {},
        "v1IndustryListFilterApi": {
            "id": [
                4
            ],
            "query": [
                4
            ],
            "textId": [
                4
            ],
            "__typename": [
                4
            ]
        },
        "v1JobExperiences": {
            "companyInferredIndustries": [
                4
            ],
            "companyV2Id": [
                4
            ],
            "description": [
                4
            ],
            "endDate": [
                4
            ],
            "experienceId": [
                4
            ],
            "jobRole": [
                4
            ],
            "name": [
                4
            ],
            "startDate": [
                4
            ],
            "__typename": [
                4
            ]
        },
        "v1JobExperiencesInput": {
            "companyId": [
                4
            ],
            "companyInferredIndustries": [
                4
            ],
            "companyV2Id": [
                4
            ],
            "description": [
                4
            ],
            "endDate": [
                4
            ],
            "experienceId": [
                4
            ],
            "jobRole": [
                4
            ],
            "name": [
                4
            ],
            "startDate": [
                4
            ],
            "__typename": [
                4
            ]
        },
        "v1ListCitiesOutput": {
            "cities": [
                4
            ],
            "metadata": [
                2
            ],
            "__typename": [
                4
            ]
        },
        "v1ListCompaniesOutput": {
            "companies": [
                21
            ],
            "currentPage": [
                7
            ],
            "metadata": [
                2
            ],
            "pageSize": [
                7
            ],
            "totalPages": [
                7
            ],
            "totalRecords": [
                7
            ],
            "__typename": [
                4
            ]
        },
        "v1ListEmbeddingsOutput": {
            "embeddings": [
                28
            ],
            "__typename": [
                4
            ]
        },
        "v1ListIndustriesOutput": {
            "currentPage": [
                7
            ],
            "industries": [
                42
            ],
            "metadata": [
                2
            ],
            "pageSize": [
                7
            ],
            "totalPages": [
                7
            ],
            "totalRecords": [
                7
            ],
            "__typename": [
                4
            ]
        },
        "v1ListProvincesOutput": {
            "metadata": [
                2
            ],
            "provinces": [
                79
            ],
            "__typename": [
                4
            ]
        },
        "v1ListRoleCategoriesOutput": {
            "currentPage": [
                7
            ],
            "metadata": [
                2
            ],
            "pageSize": [
                7
            ],
            "roleCategories": [
                81
            ],
            "totalPages": [
                7
            ],
            "totalRecords": [
                7
            ],
            "__typename": [
                4
            ]
        },
        "v1ListSkillsOutput": {
            "currentPage": [
                7
            ],
            "metadata": [
                2
            ],
            "pageSize": [
                7
            ],
            "skills": [
                103
            ],
            "totalPages": [
                7
            ],
            "totalRecords": [
                7
            ],
            "__typename": [
                4
            ]
        },
        "v1ListUsersOutput": {
            "currentPage": [
                7
            ],
            "metadata": [
                2
            ],
            "pageSize": [
                7
            ],
            "totalPages": [
                7
            ],
            "totalRecords": [
                7
            ],
            "users": [
                126
            ],
            "__typename": [
                4
            ]
        },
        "v1MissionApplicationAvailability": {
            "hoursPerWeek": [
                7
            ],
            "notes": [
                4
            ],
            "startDate": [
                4
            ],
            "__typename": [
                4
            ]
        },
        "v1MissionApplicationChanges": {
            "aboutUpdatedAt": [
                1
            ],
            "availabilityUpdatedAt": [
                1
            ],
            "lastHourlyRateRange": [
                59
            ],
            "lastReviewAt": [
                1
            ],
            "noteOnAvailabilityUpdatedAt": [
                1
            ],
            "pitchUpdatedAt": [
                1
            ],
            "rateUpdatedAt": [
                1
            ],
            "workingHoursUpdatedAt": [
                1
            ],
            "__typename": [
                4
            ]
        },
        "v1MissionApplicationEntityApi": {
            "_id": [
                4
            ],
            "about": [
                4
            ],
            "analysis": [
                4
            ],
            "availability": [
                56
            ],
            "changes": [
                57
            ],
            "createdAt": [
                1
            ],
            "hiddenProjects": [
                4
            ],
            "hourlyRateRange": [
                59
            ],
            "inProposal": [
                6
            ],
            "internalStatus": [
                60
            ],
            "lookingForApplicationsWhenCreated": [
                6
            ],
            "lowCompetitiveness": [
                4
            ],
            "metadata": [
                2
            ],
            "migrations": [
                4
            ],
            "pitch": [
                4
            ],
            "proposal": [
                4
            ],
            "proposalManuallySharedAt": [
                1
            ],
            "proposedRates": [
                61
            ],
            "proposedToClient": [
                4
            ],
            "proposedToClientAt": [
                1
            ],
            "rejectionReason": [
                2
            ],
            "reviewStatus": [
                62
            ],
            "reviewStatusChanges": [
                4
            ],
            "role": [
                4
            ],
            "roleHistory": [
                63
            ],
            "status": [
                4
            ],
            "updatedAt": [
                1
            ],
            "updatedStatusAt": [
                1
            ],
            "user": [
                4
            ],
            "withdrawn": [
                6
            ],
            "workingHours": [
                70
            ],
            "__typename": [
                4
            ]
        },
        "v1MissionApplicationHourlyRateRange": {
            "max": [
                14
            ],
            "min": [
                14
            ],
            "__typename": [
                4
            ]
        },
        "v1MissionApplicationInternalStatus": {},
        "v1MissionApplicationProposedRates": {
            "builderHourlyRate": [
                14
            ],
            "clientHourlyRate": [
                14
            ],
            "__typename": [
                4
            ]
        },
        "v1MissionApplicationReviewStatus": {
            "notSelected": [
                4
            ],
            "opportunityToUpdate": [
                4
            ],
            "other": [
                4
            ],
            "waitlisted": [
                4
            ],
            "__typename": [
                4
            ]
        },
        "v1MissionApplicationRoleHistory": {
            "date": [
                4
            ],
            "role": [
                4
            ],
            "user": [
                4
            ],
            "__typename": [
                4
            ]
        },
        "v1MissionAttachedLink": {
            "URL": [
                4
            ],
            "title": [
                4
            ],
            "__typename": [
                4
            ]
        },
        "v1MissionEntityApi": {
            "_id": [
                4
            ],
            "accountId": [
                4
            ],
            "applyStatus": [
                4
            ],
            "attachedLinks": [
                64
            ],
            "bdOwners": [
                4
            ],
            "billingPeriod": [
                4
            ],
            "clientCompany": [
                4
            ],
            "clientMargin": [
                14
            ],
            "companyStory": [
                4
            ],
            "createdAt": [
                1
            ],
            "creatorUser": [
                4
            ],
            "description": [
                4
            ],
            "expectedCommitment": [
                4
            ],
            "expectedDurationMonths": [
                7
            ],
            "hidden": [
                6
            ],
            "hubspotDealId": [
                4
            ],
            "internalDescription": [
                4
            ],
            "invoiceEmailGreeting": [
                4
            ],
            "lastDeployedAt": [
                1
            ],
            "logoURL": [
                4
            ],
            "mainManagerUserId": [
                4
            ],
            "managers": [
                66
            ],
            "metadata": [
                2
            ],
            "migrations": [
                4
            ],
            "missionSpecId": [
                4
            ],
            "promotedTags": [
                4
            ],
            "publishedAt": [
                1
            ],
            "publisherUser": [
                4
            ],
            "roles": [
                67
            ],
            "rolesMargin": [
                14
            ],
            "skipContracts": [
                4
            ],
            "status": [
                4
            ],
            "stripeClient": [
                4
            ],
            "talentIndustries": [
                4
            ],
            "title": [
                4
            ],
            "updatedAt": [
                4
            ],
            "videoURL": [
                4
            ],
            "website": [
                4
            ],
            "__typename": [
                4
            ]
        },
        "v1MissionManager": {
            "_id": [
                4
            ],
            "accessMode": [
                4
            ],
            "excludeFromInvoiceEmails": [
                6
            ],
            "excludeFromTeamPulseEmails": [
                6
            ],
            "__typename": [
                4
            ]
        },
        "v1MissionRoleEntityApi": {
            "_id": [
                4
            ],
            "availability": [
                69
            ],
            "builderRateMax": [
                14
            ],
            "builderRateMin": [
                14
            ],
            "category": [
                4
            ],
            "fullName": [
                4
            ],
            "headline": [
                4
            ],
            "hourlyRate": [
                14
            ],
            "locations": [
                4
            ],
            "lookingForApplications": [
                6
            ],
            "marginVAT": [
                14
            ],
            "preferredSkills": [
                68
            ],
            "requiredSkills": [
                68
            ],
            "showRateRangeToBuilders": [
                6
            ],
            "status": [
                4
            ],
            "updatedAt": [
                1
            ],
            "user": [
                4
            ],
            "userAssignedAt": [
                1
            ],
            "utcOffsetRange": [
                2
            ],
            "workingHours": [
                70
            ],
            "__typename": [
                4
            ]
        },
        "v1MissionRoleSkill": {
            "rating": [
                4
            ],
            "talentSkillId": [
                4
            ],
            "__typename": [
                4
            ]
        },
        "v1MissionRoleVisibility": {
            "date": [
                1
            ],
            "weeklyHoursAvailable": [
                14
            ],
            "__typename": [
                4
            ]
        },
        "v1MissionRoleWorkingHours": {
            "daily": [
                71
            ],
            "name": [
                4
            ],
            "numberOfMinutesOverlap": [
                14
            ],
            "utcOffset": [
                14
            ],
            "__typename": [
                4
            ]
        },
        "v1MissionRoleWorkingHoursDaily": {
            "endTime": [
                7
            ],
            "startTime": [
                7
            ],
            "__typename": [
                4
            ]
        },
        "v1NotificationEntryGQL": {
            "id": [
                4
            ],
            "metadata": [
                73
            ],
            "__typename": [
                4
            ]
        },
        "v1NotificationMetadataGQL": {
            "emailType": [
                4
            ],
            "time": [
                1
            ],
            "__typename": [
                4
            ]
        },
        "v1NotificationPreferences": {
            "categoriesDisabledAutomatically": [
                4
            ],
            "disabledCategories": [
                4
            ],
            "emailNotificationsBlockedAt": [
                1
            ],
            "pauseNotifications": [
                76
            ],
            "__typename": [
                4
            ]
        },
        "v1NotificationsIndex": {
            "missions": [
                72
            ],
            "notifications": [
                72
            ],
            "roles": [
                72
            ],
            "__typename": [
                4
            ]
        },
        "v1PauseNotifications": {
            "endDate": [
                1
            ],
            "startDate": [
                1
            ],
            "__typename": [
                4
            ]
        },
        "v1ProjectExperiences": {
            "companyV2Id": [
                4
            ],
            "completenessScore": [
                14
            ],
            "description": [
                4
            ],
            "endDate": [
                4
            ],
            "experienceId": [
                4
            ],
            "industries": [
                4
            ],
            "jobRole": [
                4
            ],
            "skills": [
                4
            ],
            "startDate": [
                4
            ],
            "title": [
                4
            ],
            "__typename": [
                4
            ]
        },
        "v1ProjectExperiencesInput": {
            "companyId": [
                4
            ],
            "companyV2Id": [
                4
            ],
            "completenessScore": [
                14
            ],
            "description": [
                4
            ],
            "endDate": [
                4
            ],
            "experienceId": [
                4
            ],
            "industries": [
                4
            ],
            "jobRole": [
                4
            ],
            "skills": [
                4
            ],
            "startDate": [
                4
            ],
            "title": [
                4
            ],
            "__typename": [
                4
            ]
        },
        "v1ProvinceEntityApi": {
            "country": [
                4
            ],
            "province": [
                4
            ],
            "__typename": [
                4
            ]
        },
        "v1ProvinceListFilterApi": {
            "countryCode": [
                4
            ],
            "__typename": [
                4
            ]
        },
        "v1RoleCategoryEntityApi": {
            "_id": [
                4
            ],
            "anchors": [
                4
            ],
            "group": [
                4
            ],
            "talentCategoryIds": [
                4
            ],
            "title": [
                4
            ],
            "__typename": [
                4
            ]
        },
        "v1RoleCategoryListFilterApi": {
            "id": [
                4
            ],
            "query": [
                4
            ],
            "__typename": [
                4
            ]
        },
        "v1SearchIndustriesExperience": {
            "industryId": [
                4
            ],
            "minYearsOfExperience": [
                7
            ],
            "__typename": [
                4
            ]
        },
        "v1SearchMissionAggregation": {
            "missionOwner": [
                31
            ],
            "missionTalentIndustry": [
                31
            ],
            "roleCategory": [
                31
            ],
            "roleSkill": [
                31
            ],
            "__typename": [
                4
            ]
        },
        "v1SearchMissionApplicationFilterApi": {
            "excludeId": [
                4
            ],
            "id": [
                4
            ],
            "roleId": [
                4
            ],
            "status": [
                4
            ],
            "userId": [
                4
            ],
            "__typename": [
                4
            ]
        },
        "v1SearchMissionApplicationsOutput": {
            "currentPage": [
                7
            ],
            "metadata": [
                2
            ],
            "missionApplications": [
                58
            ],
            "pageSize": [
                7
            ],
            "totalPages": [
                7
            ],
            "totalRecords": [
                7
            ],
            "__typename": [
                4
            ]
        },
        "v1SearchMissionFilterApi": {
            "activelyDrafting": [
                6
            ],
            "applyStatus": [
                4
            ],
            "excludeIds": [
                4
            ],
            "ids": [
                4
            ],
            "locations": [
                4
            ],
            "missionStatus": [
                4
            ],
            "query": [
                4
            ],
            "roleCategoryIds": [
                4
            ],
            "roleStatus": [
                4
            ],
            "workingHoursOverlap": [
                96
            ],
            "__typename": [
                4
            ]
        },
        "v1SearchMissionsOutput": {
            "aggregations": [
                84
            ],
            "currentPage": [
                7
            ],
            "metadata": [
                2
            ],
            "missions": [
                65
            ],
            "pageSize": [
                7
            ],
            "totalPages": [
                7
            ],
            "totalRecords": [
                7
            ],
            "__typename": [
                4
            ]
        },
        "v1SearchType": {},
        "v1SearchUserFilterApi": {
            "accentScore": [
                7
            ],
            "accentScoreOperator": [
                4
            ],
            "activeOnMission": [
                6
            ],
            "appliedForRoles": [
                4
            ],
            "appliedSince": [
                4
            ],
            "appliedSinceExclude": [
                6
            ],
            "badges": [
                125
            ],
            "calComNextAvailabilityMax": [
                4
            ],
            "cities": [
                4
            ],
            "communityBadges": [
                4
            ],
            "companies": [
                4
            ],
            "companiesV2": [
                4
            ],
            "countries": [
                4
            ],
            "createdAtFrom": [
                4
            ],
            "createdAtTo": [
                4
            ],
            "customTags": [
                4
            ],
            "dateAvailableFrom": [
                4
            ],
            "declaredIndustryYearsOfExperience": [
                7
            ],
            "emailTypesToExclude": [
                4
            ],
            "emailTypesToInclude": [
                4
            ],
            "emails": [
                4
            ],
            "englishScore": [
                7
            ],
            "englishScoreOperator": [
                4
            ],
            "excludeAppliedForRoles": [
                6
            ],
            "excludeAppliedStatus": [
                6
            ],
            "excludeBuildersWithPerformanceIssue": [
                6
            ],
            "excludeCustomTags": [
                6
            ],
            "excludeEmailNotificationsBlocked": [
                6
            ],
            "excludeIds": [
                4
            ],
            "excludeNotInterestedRoles": [
                6
            ],
            "excludeNotifiedRoles": [
                6
            ],
            "excludeOnHoldApplicants": [
                6
            ],
            "excludedTags": [
                4
            ],
            "expertiseScore": [
                7
            ],
            "expertiseScoreOperator": [
                4
            ],
            "hasZeroToOneExperience": [
                6
            ],
            "highQualityProfile": [
                14
            ],
            "highQualityProfileOperator": [
                4
            ],
            "highQualityProfileV1": [
                14
            ],
            "hourlyRateFlexibility": [
                14
            ],
            "hourlyRateMax": [
                7
            ],
            "hourlyRateMin": [
                7
            ],
            "hourlyRateRangeExtrapolationFactor": [
                14
            ],
            "id": [
                4
            ],
            "ids": [
                4
            ],
            "includeAdjacentSpecializations": [
                6
            ],
            "includeAppliedIndustries": [
                6
            ],
            "includeAppliedSkills": [
                6
            ],
            "includeCategoriesDisabledAutomatically": [
                6
            ],
            "includeMissingCity": [
                6
            ],
            "includeMissingCountry": [
                6
            ],
            "includeMissingProvince": [
                6
            ],
            "includeNotAvailable": [
                6
            ],
            "includePausedNotifications": [
                6
            ],
            "includeSuggestedExperiences": [
                6
            ],
            "includeSuggestedSkills": [
                6
            ],
            "includeSuggestedSpecializations": [
                6
            ],
            "includeUnknownAvailability": [
                6
            ],
            "industriesExperience": [
                83
            ],
            "interactionExperienceScore": [
                7
            ],
            "interactionExperienceScoreOperator": [
                4
            ],
            "isAdmin": [
                6
            ],
            "isManagementExperiencePreferred": [
                6
            ],
            "isVerified": [
                6
            ],
            "isVetter": [
                6
            ],
            "isWorkingHoursOverlapPreferred": [
                6
            ],
            "isZeroToOneExperiencePreferred": [
                6
            ],
            "keywordSearchSources": [
                91
            ],
            "lastLoginAt": [
                1
            ],
            "lastLoginAtExclude": [
                6
            ],
            "managementExperience": [
                92
            ],
            "minYearsExperience": [
                7
            ],
            "minimumRequiredAvailableHours": [
                7
            ],
            "minimumRequiredSkills": [
                7
            ],
            "missionStatusDate": [
                4
            ],
            "neighbors": [
                7
            ],
            "notInterestedRoles": [
                4
            ],
            "notifiedRoles": [
                4
            ],
            "optedOutOfClientDiscovery": [
                6
            ],
            "preferredIndustries": [
                4
            ],
            "preferredSkills": [
                4
            ],
            "preferredTags": [
                4
            ],
            "profileCompleteness": [
                14
            ],
            "profileCompletenessOperator": [
                4
            ],
            "profileCompletenessV1": [
                14
            ],
            "profilePictureIssuesToExclude": [
                4
            ],
            "provinces": [
                4
            ],
            "query": [
                4
            ],
            "requireAllCustomTags": [
                6
            ],
            "requireAllExcludedTags": [
                6
            ],
            "requireAllIndustries": [
                6
            ],
            "requireAllIndustriesExperience": [
                6
            ],
            "requireAllSelectedNotificationCategories": [
                6
            ],
            "requireAllSkills": [
                6
            ],
            "requireAssignedSpecialization": [
                6
            ],
            "requireAutomaticallyDisabledCategories": [
                6
            ],
            "requireAvailability": [
                6
            ],
            "requireCity": [
                6
            ],
            "requireCountry": [
                6
            ],
            "requireCurrentlyInterviewing": [
                6
            ],
            "requireCurrentlyProposed": [
                6
            ],
            "requireEmailNotificationsBlocked": [
                6
            ],
            "requireHighQualityProfile": [
                6
            ],
            "requireHighQualityProfileV1": [
                6
            ],
            "requireMainSpecialization": [
                6
            ],
            "requireProfileCompletenessV1": [
                6
            ],
            "requireProposedSkills": [
                6
            ],
            "requireProposedSpecializations": [
                6
            ],
            "requireProvince": [
                6
            ],
            "requireScheduledToEnd": [
                6
            ],
            "requireSuggestedBuilderHourlyRate": [
                6
            ],
            "requireUserHasCalendarConnected": [
                6
            ],
            "requireVerifiedSkills": [
                6
            ],
            "requiredIndustries": [
                4
            ],
            "requiredNotificationCategories": [
                4
            ],
            "requiredSkills": [
                95
            ],
            "roleApplicationStatus": [
                93
            ],
            "scoreStrictness": [
                14
            ],
            "scrubbed": [
                133
            ],
            "scrubbedDateFrom": [
                4
            ],
            "scrubbedDateTo": [
                4
            ],
            "searchAfter": [
                2
            ],
            "searchType": [
                89
            ],
            "semanticSearchQuery": [
                4
            ],
            "similarBuildersNeighbors": [
                7
            ],
            "similarBuildersSearchQuery": [
                14
            ],
            "specializations": [
                4
            ],
            "status": [
                134
            ],
            "suggestedBuilderHourlyRateMax": [
                7
            ],
            "suggestedBuilderHourlyRateMin": [
                7
            ],
            "suggestedSkillsMinConfidence": [
                14
            ],
            "suggestedSpecializationsMinConfidence": [
                14
            ],
            "type": [
                142
            ],
            "useEstimatedAvailability": [
                6
            ],
            "useQueryKeywordForSorting": [
                6
            ],
            "useTrustedTalentProfile": [
                6
            ],
            "weeklyHoursAvailabilityFlexibility": [
                7
            ],
            "workingHoursOverlap": [
                96
            ],
            "__typename": [
                4
            ]
        },
        "v1SearchUserFilterApiKeywordSource": {},
        "v1SearchUserFilterApiManagementExperience": {},
        "v1SearchUserFilterApiRoleApplicationStatus": {},
        "v1SearchUserRankingCalibrationApi": {
            "additionalSpecializationBoostingFactor": [
                14
            ],
            "calendarConnectedBoostingFactor": [
                14
            ],
            "cityBoostingFactor": [
                14
            ],
            "companyBoostingFactor": [
                14
            ],
            "countryBoostingFactor": [
                14
            ],
            "emailBoostingFactor": [
                14
            ],
            "exactManagementExperienceBoostingFactor": [
                14
            ],
            "highQualityProfileBoostingFactor": [
                14
            ],
            "highQualityProfileV1BoostingFactor": [
                14
            ],
            "hourlyRateDecayRateOutside": [
                14
            ],
            "hourlyRateDefaultBoostingFactorIfMissing": [
                14
            ],
            "hourlyRateMinBoostingFactor": [
                14
            ],
            "hourlyRateWithinRangeBoostingFactor": [
                14
            ],
            "hoursAvailableBoostingFactor": [
                14
            ],
            "hoursAvailableBoostingFactorForSubparAvailability": [
                14
            ],
            "immediateAvailabilityBoostingFactor": [
                14
            ],
            "industryExperienceBoostingFactor": [
                14
            ],
            "keywordBoostingFactor": [
                14
            ],
            "mainSpecializationBoostingFactor": [
                14
            ],
            "managementExperienceBoostingFactor": [
                14
            ],
            "midTermAvailabilityBoostingFactor": [
                14
            ],
            "midTermUpdateBoostingFactor": [
                14
            ],
            "nearRangeBoostingFactor": [
                14
            ],
            "preferredHourlyRateBoostingFactor": [
                14
            ],
            "preferredIndustriesBoostingFactor": [
                14
            ],
            "preferredSkillsBoostingFactor": [
                14
            ],
            "preferredTagsBoostingFactor": [
                14
            ],
            "profileCompletenessBoostingFactor": [
                14
            ],
            "profileCompletenessV1BoostingFactor": [
                14
            ],
            "provinceBoostingFactor": [
                14
            ],
            "recentUpdateBoostingFactor": [
                14
            ],
            "requiredIndustriesBoostingFactor": [
                14
            ],
            "requiredSkillsBoostingFactor": [
                14
            ],
            "requiredTagsBoostingFactor": [
                14
            ],
            "rrfRankConstant": [
                7
            ],
            "scoreStrictnessFactor": [
                14
            ],
            "semanticSearchBoost": [
                14
            ],
            "shortTermAvailabilityBoostingFactor": [
                14
            ],
            "similarBuildersSearchBoost": [
                14
            ],
            "zeroToOneBoostingFactor": [
                14
            ],
            "__typename": [
                4
            ]
        },
        "v1SearchUserSkills": {
            "rating": [
                7
            ],
            "sid": [
                4
            ],
            "__typename": [
                4
            ]
        },
        "v1SearchUserWorkingHoursOverlap": {
            "intervals": [
                97
            ],
            "matchUsersWithoutOverlap": [
                6
            ],
            "minutes": [
                7
            ],
            "startDate": [
                4
            ],
            "timezone": [
                4
            ],
            "__typename": [
                4
            ]
        },
        "v1SearchUserWorkingHoursOverlapInterval": {
            "endTime": [
                7
            ],
            "startTime": [
                7
            ],
            "__typename": [
                4
            ]
        },
        "v1SearchUsersOutput": {
            "currentPage": [
                7
            ],
            "metadata": [
                2
            ],
            "pageSize": [
                7
            ],
            "totalPages": [
                7
            ],
            "totalRecords": [
                7
            ],
            "users": [
                126
            ],
            "__typename": [
                4
            ]
        },
        "v1SemanticSearch": {
            "embeddedAt": [
                1
            ],
            "ref": [
                4
            ],
            "type": [
                4
            ],
            "vector": [
                14
            ],
            "__typename": [
                4
            ]
        },
        "v1SemanticSearchInput": {
            "embeddedAt": [
                1
            ],
            "ref": [
                4
            ],
            "text": [
                4
            ],
            "type": [
                4
            ],
            "vector": [
                14
            ],
            "__typename": [
                4
            ]
        },
        "v1SimilarBuilder": {
            "indexedDate": [
                1
            ],
            "score": [
                14
            ],
            "uid": [
                4
            ],
            "__typename": [
                4
            ]
        },
        "v1SimilarBuilderEntry": {
            "indexedDate": [
                1
            ],
            "score": [
                14
            ],
            "uid": [
                4
            ],
            "__typename": [
                4
            ]
        },
        "v1SkillEntityApi": {
            "_id": [
                4
            ],
            "aliases": [
                4
            ],
            "isProgrammingLanguage": [
                6
            ],
            "isVettingEligible": [
                6
            ],
            "name": [
                4
            ],
            "nodeType": [
                4
            ],
            "parentTalentCategoryIds": [
                4
            ],
            "textId": [
                4
            ],
            "__typename": [
                4
            ]
        },
        "v1SkillListFilterApi": {
            "id": [
                4
            ],
            "isProgrammingLanguage": [
                6
            ],
            "isVerified": [
                6
            ],
            "isVettingEligible": [
                6
            ],
            "nodeType": [
                4
            ],
            "query": [
                4
            ],
            "talentCategoryIds": [
                4
            ],
            "textId": [
                4
            ],
            "__typename": [
                4
            ]
        },
        "v1StructuredCompanyEnrichment": {
            "city": [
                4
            ],
            "companyStage": [
                4
            ],
            "countryCode": [
                4
            ],
            "industries": [
                4
            ],
            "logoUrl": [
                4
            ],
            "name": [
                4
            ],
            "timezone": [
                4
            ],
            "__typename": [
                4
            ]
        },
        "v1SuggestUsersFilterApi": {
            "query": [
                4
            ],
            "__typename": [
                4
            ]
        },
        "v1SuggestUsersOutput": {
            "currentPage": [
                7
            ],
            "metadata": [
                2
            ],
            "pageSize": [
                7
            ],
            "suggestions": [
                108
            ],
            "totalPages": [
                7
            ],
            "totalRecords": [
                7
            ],
            "__typename": [
                4
            ]
        },
        "v1SuggestUsersSuggestionApi": {
            "createdAt": [
                4
            ],
            "displayEmail": [
                4
            ],
            "email": [
                4
            ],
            "fullName": [
                4
            ],
            "metadata": [
                2
            ],
            "score": [
                14
            ],
            "text": [
                4
            ],
            "uid": [
                4
            ],
            "updatedAt": [
                4
            ],
            "__typename": [
                4
            ]
        },
        "v1SuggestedJobExperiences": {
            "companyName": [
                4
            ],
            "description": [
                4
            ],
            "endDate": [
                4
            ],
            "jobRole": [
                4
            ],
            "name": [
                4
            ],
            "source": [
                4
            ],
            "startDate": [
                4
            ],
            "__typename": [
                4
            ]
        },
        "v1SuggestedJobExperiencesInput": {
            "companyName": [
                4
            ],
            "description": [
                4
            ],
            "endDate": [
                4
            ],
            "jobRole": [
                4
            ],
            "name": [
                4
            ],
            "source": [
                4
            ],
            "startDate": [
                4
            ],
            "__typename": [
                4
            ]
        },
        "v1SuggestedProjectExperiences": {
            "companyName": [
                4
            ],
            "description": [
                4
            ],
            "endDate": [
                4
            ],
            "industries": [
                4
            ],
            "jobRole": [
                4
            ],
            "skills": [
                4
            ],
            "startDate": [
                4
            ],
            "title": [
                4
            ],
            "__typename": [
                4
            ]
        },
        "v1SuggestedProjectExperiencesInput": {
            "companyName": [
                4
            ],
            "description": [
                4
            ],
            "endDate": [
                4
            ],
            "industries": [
                4
            ],
            "jobRole": [
                4
            ],
            "skills": [
                4
            ],
            "startDate": [
                4
            ],
            "title": [
                4
            ],
            "__typename": [
                4
            ]
        },
        "v1TimesheetSummaryEntry": {
            "mission": [
                4
            ],
            "role": [
                4
            ],
            "summary": [
                4
            ],
            "timestamp": [
                1
            ],
            "useAI": [
                6
            ],
            "__typename": [
                4
            ]
        },
        "v1TimesheetSummaryInput": {
            "mission": [
                4
            ],
            "role": [
                4
            ],
            "summary": [
                4
            ],
            "timestamp": [
                1
            ],
            "useAI": [
                6
            ],
            "__typename": [
                4
            ]
        },
        "v1TranscriptInput": {
            "id": [
                4
            ],
            "text": [
                4
            ],
            "type": [
                4
            ],
            "__typename": [
                4
            ]
        },
        "v1TranscriptSearch": {
            "id": [
                4
            ],
            "text": [
                4
            ],
            "type": [
                4
            ],
            "__typename": [
                4
            ]
        },
        "v1UpdateCompaniesOutput": {
            "companies": [
                21
            ],
            "currentPage": [
                7
            ],
            "metadata": [
                2
            ],
            "pageSize": [
                7
            ],
            "totalPages": [
                7
            ],
            "totalRecords": [
                7
            ],
            "__typename": [
                4
            ]
        },
        "v1UpdateCompanyData": {
            "allDomains": [
                4
            ],
            "childIds": [
                4
            ],
            "domainAliases": [
                4
            ],
            "employeeCount": [
                7
            ],
            "fld": [
                4
            ],
            "nameAliases": [
                4
            ],
            "parentId": [
                4
            ],
            "__typename": [
                4
            ]
        },
        "v1UpdateEmbeddingsOutput": {
            "currentPage": [
                7
            ],
            "metadata": [
                2
            ],
            "pageSize": [
                7
            ],
            "totalPages": [
                7
            ],
            "totalRecords": [
                7
            ],
            "users": [
                29
            ],
            "__typename": [
                4
            ]
        },
        "v1UpdateUserNotificationsOutput": {
            "failedUpdateUsers": [
                4
            ],
            "metadata": [
                2
            ],
            "missions": [
                2
            ],
            "notifications": [
                2
            ],
            "roles": [
                2
            ],
            "updatedUserCount": [
                7
            ],
            "__typename": [
                4
            ]
        },
        "v1UpdateUserOutput": {
            "currentPage": [
                7
            ],
            "metadata": [
                2
            ],
            "pageSize": [
                7
            ],
            "totalPages": [
                7
            ],
            "totalRecords": [
                7
            ],
            "user": [
                126
            ],
            "__typename": [
                4
            ]
        },
        "v1UpdateUsersOutput": {
            "currentPage": [
                7
            ],
            "metadata": [
                2
            ],
            "pageSize": [
                7
            ],
            "totalPages": [
                7
            ],
            "totalRecords": [
                7
            ],
            "users": [
                126
            ],
            "__typename": [
                4
            ]
        },
        "v1UserAdminNoteScore": {
            "accent": [
                7
            ],
            "english": [
                7
            ],
            "expertise": [
                7
            ],
            "interactionExperience": [
                7
            ],
            "__typename": [
                4
            ]
        },
        "v1UserAdminNotes": {
            "markedAsRejectedAt": [
                1
            ],
            "notes": [
                2
            ],
            "rejectionEmailSentAt": [
                1
            ],
            "scores": [
                123
            ],
            "__typename": [
                4
            ]
        },
        "v1UserBadge": {},
        "v1UserEntityApi": {
            "aboutMe": [
                4
            ],
            "accentScore": [
                7
            ],
            "activatedAt": [
                1
            ],
            "activeOnMission": [
                6
            ],
            "activeRoles": [
                4
            ],
            "additionalTalentSkills": [
                138
            ],
            "additionalTalentSpecializations": [
                139
            ],
            "addressStr": [
                4
            ],
            "adminNotes": [
                124
            ],
            "appliedIndustries": [
                4
            ],
            "appliedRoles": [
                4
            ],
            "appliedSkills": [
                4
            ],
            "assignedRoles": [
                4
            ],
            "assignedSpecializations": [
                4
            ],
            "availability": [
                2
            ],
            "badges": [
                4
            ],
            "blurbs": [
                2
            ],
            "calComConnected": [
                6
            ],
            "calComNextAvailabilityUTC": [
                4
            ],
            "calComUserId": [
                7
            ],
            "calculatedYearsOfExperience": [
                7
            ],
            "communityBadges": [
                4
            ],
            "companies": [
                2
            ],
            "companiesV2": [
                23
            ],
            "companyIds": [
                4
            ],
            "companyV2Ids": [
                4
            ],
            "createdAt": [
                4
            ],
            "currentlyInterviewing": [
                4
            ],
            "currentlyProposed": [
                4
            ],
            "customCalendar": [
                2
            ],
            "customTags": [
                4
            ],
            "cvURL": [
                4
            ],
            "declaredProjectIndustries": [
                4
            ],
            "displayEmail": [
                4
            ],
            "dribbble": [
                4
            ],
            "email": [
                4
            ],
            "emailNotificationsBlocked": [
                6
            ],
            "embeddingsUpdatedAt": [
                4
            ],
            "endedRoles": [
                4
            ],
            "englishScore": [
                7
            ],
            "estimatedAvailability": [
                14
            ],
            "expertiseScore": [
                7
            ],
            "firstName": [
                4
            ],
            "fullName": [
                4
            ],
            "github": [
                129
            ],
            "hasPerformanceIssue": [
                6
            ],
            "highQualityProfile": [
                14
            ],
            "highQualityProfileV1": [
                14
            ],
            "hourlyRate": [
                127
            ],
            "industriesExperience": [
                41
            ],
            "industriesExperienceWithSuggestions": [
                41
            ],
            "interactionExperienceScore": [
                7
            ],
            "isAdmin": [
                6
            ],
            "isUsingSharedCalendar": [
                6
            ],
            "isVetter": [
                6
            ],
            "jobExperiences": [
                2
            ],
            "jobExperiencesTyped": [
                46
            ],
            "lastLoginAt": [
                1
            ],
            "lastName": [
                4
            ],
            "latestApplicationDate": [
                4
            ],
            "latestAvailabilityEstimate": [
                1
            ],
            "linkedin": [
                129
            ],
            "location": [
                131
            ],
            "mainTalentSkills": [
                138
            ],
            "mainTalentSpecialization": [
                139
            ],
            "matchedOnQueries": [
                4
            ],
            "matchedOnSemanticQuery": [
                2
            ],
            "metadata": [
                2
            ],
            "missionApplicationPitches": [
                2
            ],
            "missionStatusDate": [
                4
            ],
            "monstacheUpdatedAt": [
                1
            ],
            "notInterestedRoles": [
                4
            ],
            "notificationPreferences": [
                74
            ],
            "notifications": [
                75
            ],
            "pictureURL": [
                4
            ],
            "pipelineUpdatedAt": [
                4
            ],
            "profileCompleteness": [
                14
            ],
            "profileCompletenessOperator": [
                4
            ],
            "profileCompletenessV1": [
                14
            ],
            "profilePictureIssues": [
                4
            ],
            "profilePictureURL": [
                4
            ],
            "profileScore": [
                14
            ],
            "profileURL": [
                4
            ],
            "profileVector": [
                14
            ],
            "projectExperiences": [
                2
            ],
            "projectExperiencesTyped": [
                77
            ],
            "proposalCount": [
                7
            ],
            "proposedSkills": [
                4
            ],
            "proposedSpecializations": [
                4
            ],
            "rateRange": [
                127
            ],
            "recommendedRoleIds": [
                4
            ],
            "region": [
                4
            ],
            "resume": [
                4
            ],
            "scrubDate": [
                1
            ],
            "scrubbed": [
                133
            ],
            "similarBuilders": [
                102
            ],
            "status": [
                134
            ],
            "strictScore": [
                14
            ],
            "suggestedBuilderHourlyRate": [
                14
            ],
            "suggestedJobExperiences": [
                109
            ],
            "suggestedProjectExperiences": [
                111
            ],
            "suggestedSkills": [
                35
            ],
            "suggestedSpecializations": [
                35
            ],
            "talentIndustries": [
                42
            ],
            "talentProfile": [
                2
            ],
            "timesheetSummaries": [
                113
            ],
            "title": [
                4
            ],
            "titles": [
                4
            ],
            "transcripts": [
                116
            ],
            "trustedTalentProfile": [
                135
            ],
            "type": [
                142
            ],
            "uid": [
                4
            ],
            "updatedAt": [
                4
            ],
            "username": [
                4
            ],
            "vectorizedTexts": [
                99
            ],
            "verified": [
                6
            ],
            "verifiedSkills": [
                4
            ],
            "vettingDetails": [
                2
            ],
            "websites": [
                4
            ],
            "workingHours": [
                143
            ],
            "yearsExperience": [
                7
            ],
            "yearsExperienceStartDate": [
                1
            ],
            "__typename": [
                4
            ]
        },
        "v1UserHourlyRate": {
            "max": [
                14
            ],
            "min": [
                14
            ],
            "__typename": [
                4
            ]
        },
        "v1UserHourlyRateInput": {
            "max": [
                14
            ],
            "min": [
                14
            ],
            "__typename": [
                4
            ]
        },
        "v1UserLinkedIn": {
            "username": [
                4
            ],
            "__typename": [
                4
            ]
        },
        "v1UserListFilterApi": {
            "id": [
                4
            ],
            "isAdmin": [
                6
            ],
            "isVerified": [
                6
            ],
            "isVetter": [
                6
            ],
            "query": [
                4
            ],
            "scrubbed": [
                133
            ],
            "status": [
                134
            ],
            "type": [
                142
            ],
            "__typename": [
                4
            ]
        },
        "v1UserLocation": {
            "city": [
                4
            ],
            "country": [
                4
            ],
            "countryShortName": [
                4
            ],
            "province": [
                4
            ],
            "__typename": [
                4
            ]
        },
        "v1UserNotificationInput": {
            "emailType": [
                4
            ],
            "missionId": [
                4
            ],
            "notificationId": [
                4
            ],
            "roleId": [
                4
            ],
            "time": [
                1
            ],
            "userId": [
                4
            ],
            "__typename": [
                4
            ]
        },
        "v1UserScrubbed": {},
        "v1UserStatus": {},
        "v1UserTalentProfile": {
            "additionalTalentSpecializationIds": [
                4
            ],
            "mainTalentSpecializationId": [
                4
            ],
            "talentIndustries": [
                2
            ],
            "talentSkills": [
                137
            ],
            "__typename": [
                4
            ]
        },
        "v1UserTalentProfileSkillEntry": {
            "rating": [
                7
            ],
            "talentSkillId": [
                4
            ],
            "__typename": [
                4
            ]
        },
        "v1UserTalentProfileSkills": {
            "additionalTalentSkills": [
                136
            ],
            "allTalentSkills": [
                136
            ],
            "mainTalentSkills": [
                136
            ],
            "__typename": [
                4
            ]
        },
        "v1UserTalentSkills": {
            "_id": [
                4
            ],
            "aliases": [
                4
            ],
            "isProgrammingLanguage": [
                6
            ],
            "isVettingEligible": [
                6
            ],
            "name": [
                4
            ],
            "nodeType": [
                4
            ],
            "parentTalentCategoryIds": [
                4
            ],
            "rating": [
                7
            ],
            "textId": [
                4
            ],
            "__typename": [
                4
            ]
        },
        "v1UserTalentSpecializations": {
            "_id": [
                4
            ],
            "anchors": [
                4
            ],
            "group": [
                4
            ],
            "talentCategoryIds": [
                4
            ],
            "title": [
                4
            ],
            "__typename": [
                4
            ]
        },
        "v1UserTrustedTalentProfile": {
            "additionalTalentSpecializationIds": [
                4
            ],
            "mainTalentSpecializationId": [
                4
            ],
            "talentSkills": [
                141
            ],
            "__typename": [
                4
            ]
        },
        "v1UserTrustedTalentProfileSkills": {
            "additionalTalentSkills": [
                2
            ],
            "mainTalentSkills": [
                2
            ],
            "__typename": [
                4
            ]
        },
        "v1UserType": {},
        "v1UserWorkingHours": {
            "daily": [
                144
            ],
            "name": [
                4
            ],
            "utcDaylightHours": [
                144
            ],
            "utcOffset": [
                7
            ],
            "utcStandardHours": [
                144
            ],
            "__typename": [
                4
            ]
        },
        "v1UserWorkingHoursSlot": {
            "endTime": [
                7
            ],
            "startTime": [
                7
            ],
            "__typename": [
                4
            ]
        }
    }
}